var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-horizontal-list',{style:(_vm.$vuetify.breakpoint.smAndDown ? 'overflow:hidden' : ''),attrs:{"items":_vm.products,"options":_vm.options},scopedSlots:_vm._u([{key:"prev",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"secondary lighten-5","elevation":"0","fab":"","rounded":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-arrow-left")])],1)]}},{key:"default",fn:function(ref){
var item = ref.item;
return [(item)?_c('product-card-slide',{attrs:{"product":item}}):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }